export const FPG_URL = `https://api.${window.location.hostname.replace('www.', '')}/fpg-bff`;
export const FPG_URL_LOCAL = "http://localhost:3000";
export const FPG_UNIT_TEST_URL = "https://fpg.example.com/fpg-bff";
export const FPG_PROXY_PATH = `/proxy-api-request`;
export const FPG_UNAUTH_PROXY_PATH = `/proxy-api-request-unauth`;

const createFPGAkamaiUrl = () => {
  const env = (window as Window)?.env?.REACT_APP_ENV;
  switch (env) {
    case "development":
      return FPG_URL;
    case "stage":
      return FPG_URL;
    case "prod":
      return FPG_URL;
    case "local":
      return FPG_URL_LOCAL;
    case "unit-test":
      return FPG_UNIT_TEST_URL;
    default:
      throw new Error("Invalid environment set for window.env.REACT_APP_ENV");
  }
};

const concatUrl = (base: string, path: string) =>
  `${base.replace(/\/?$/, "")}/${path.replace(/^\/+/, "")}`;

const createAemUrl = (aemBaseUrl: string, path: string) =>
  concatUrl(aemBaseUrl, path);

export const concatProxyUrl = (
  url: string,
  proxyPath: string = FPG_PROXY_PATH,
) => {
  const paramsString = `redirect=${url}`;
  return concatUrl(createFPGAkamaiUrl(), `${proxyPath}?${paramsString}`);
};

const createProxyUrl = (url: string) => concatProxyUrl(url, FPG_PROXY_PATH);
const createUnauthProxyUrl = (url: string) =>
  concatProxyUrl(url, FPG_UNAUTH_PROXY_PATH);

const createProxyUrlForEndpoint = (baseUrl: string, endpoint: string): string => {
  const url = concatUrl(baseUrl, endpoint);
  const urlEncoded = encodeURI(url);
  const proxyUrl = createProxyUrl(urlEncoded);
  return proxyUrl;
}

export {
  concatUrl,
  createAemUrl,
  createFPGAkamaiUrl,
  createProxyUrl,
  createUnauthProxyUrl,
  createProxyUrlForEndpoint
};
